import { Platform } from 'react-native';
import { createLogger } from '@/lib/logger';
import * as Haptics from 'expo-haptics';
import AsyncStorage from '@react-native-async-storage/async-storage';

const log = createLogger('HAPTICS');

const HAPTICS_KEY = 'haptics_enabled';

let hapticsEnabled = true;

export const initHaptics = async () => {
  try {
    const stored = await AsyncStorage.getItem(HAPTICS_KEY);
    hapticsEnabled = stored === null ? true : stored === 'true';
  } catch (error) {
    log.error('Failed to load haptics setting:', error);
    hapticsEnabled = true;
  }
};

export const setHapticsEnabled = async (enabled: boolean) => {
  try {
    hapticsEnabled = enabled;
    await AsyncStorage.setItem(HAPTICS_KEY, enabled.toString());
  } catch (error) {
    log.error('Failed to save haptics setting:', error);
  }
};

export const getHapticsEnabled = () => hapticsEnabled;

export const triggerHaptic = (type: 'success' | 'medium' | 'light' | 'heavy') => {
  if (!hapticsEnabled || Platform.OS === 'web') return;

  try {
    switch (type) {
      case 'success':
        Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
        break;
      case 'medium':
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
        break;
      case 'light':
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        break;
      case 'heavy':
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy);
        break;
    }
  } catch (error) {
    log.error('Haptic feedback error:', error);
  }
};

export const hapticsUtil = {
  workoutSaved: () => triggerHaptic('success'),
  badgeUnlocked: () => triggerHaptic('success'),
  prSubmitted: () => triggerHaptic('success'),
  duelCreated: () => triggerHaptic('medium'),
  duelWin: () => {
    triggerHaptic('success');
    setTimeout(() => triggerHaptic('heavy'), 100);
  },
  buttonPress: () => triggerHaptic('light'),
};
